module.exports = __webpack_public_path__ + "static/media/success_orange.e17fe916.png";